<script>
import "swiper/swiper-bundle.css";
import Swiper, { Scrollbar, Navigation } from "swiper";
Swiper.use([Scrollbar, Navigation]);

export default {
  name: "CommoditiesScroll",
  mounted() {
    this.swiper = new Swiper(this.$refs.swiper, {
      slidesPerView: "auto",
      freeMode: true,
      spaceBetween: 52,
      scrollbar: {
        el: ".commodities-scrollbar",
        draggable: true,
        /*dragSize: 80,*/
      },
      navigation: {
        nextEl: ".commodities-next",
        prevEl: ".commodities-prev",
      },
      
      breakpoints: {
        500: {
          spaceBetween: 62,
        }
      }
    });
    
    setTimeout(() => {
      if (this.swiper.isBeginning && this.swiper.isEnd) {
        document.querySelector(".commodities-arrows").style.display = 'none';
      }
    }, 500);
  },
};
</script>

<template>
  <div class="block-commodities-scroll">
    <div ref="swiper" class="swiper-container">
      <div class="swiper-wrapper">
        <div class="block-commodities-begin swiper-slide"></div>
        <slot />
        <div class="block-commodities-end swiper-slide"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.block-commodities-scroll {
  .swiper-container {
    width: 100%;
  }

  .swiper-wrapper {
    display: flex;
    flex-flow: row nowrap;
    align-items: stretch;
    justify-content: flex-start;

    &:deep(.swiper-slide) {
      height: auto;
    }
  }

  .block-commodities-begin {
    width: calc(
      max((100vw - 1176px) / 2, $page-margin-desktop) - 62px
    ) !important;

    @media (max-width: 1000px) {
      width: 0 !important;
    }
  }

  .block-commodities-end {
    width: 0;

    @media (max-width: 1000px) {
      width: 0;
    }
  }
}
</style>
